export const projectsData = [
  {
    project_img: "./wishkart.png",
    project_img_dark: "./wishkart_dark.png",
    title: "WishKart.com",
    description:
      "This was a group project. The Tech stack which we used to create this website are Javascript, React, Redux, and also used Chakra for UI. My role was to create Sign-In/Sign-Out with backend authentication,Admin Side to manage the website. This was a collaborative project built by a team of 5 members in 5 days.",
    tech_stack: [
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
        name: "react",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
        name: "html",
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
        name: "css",
      },
      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
        name: "chakra",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://wish-kart.vercel.app/",
    github: "https://github.com/Rajendra3049/Wishkart",
  },
  {
    project_img: "./lint.png",
    project_img_dark: "./lint_dark.png",

    title: "Lint.com",
    description:
      "This was a group project. The Tech stack which we used to create this website are Javascript, React, Redux, for 'Front-End' and Node js, MongoDB, Mongoose, JWT, Rest-API, Express js, Bcrypt, for 'Back-End' and also used Chakra for UI. My work was here to create Product Page(with dynamic data and filtration functionality), Single Product Page . This was a collaborative project built by a team of 4 members in 5 days.",
    tech_stack: [
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
        name: "react",
      },

      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
        name: "chakra",
      },

      {
        url: "https://img.icons8.com/fluency/240/node-js.png",
        name: "node",
      },
      {
        url: "https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/100/external-mongodb-a-cross-platform-document-oriented-database-program-logo-shadow-tal-revivo.png",
        name: "mongoDB",
      },
      {
        url: "https://img.icons8.com/color/256/express-js.png",
        name: "express-js",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://lint-belk.vercel.app/",
    github: "https://github.com/RimRaider639/Lint",
  },
  {
    project_img: "./wingsShooter.png",
    project_img_dark: "./wingsShooter.png",

    title: "WingsShooter(Game)",
    description:
      "Our team created a bird shooting game for our portfolio. Players click to kill birds while avoiding zombies. We used JavaScript, React, Redux, Node.js, MongoDB, Mongoose, Express.js, and Chakra. As part of my contribution to the project, I took on several key responsibilities. These included designing and developing the game's UI, crafting the player's character, and creating engaging sound effects. We were able to deliver a fully functional and immersive bird shooting game.",
    tech_stack: [
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
        name: "react",
      },

      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
        name: "chakra",
      },

      {
        url: "https://img.icons8.com/fluency/240/node-js.png",
        name: "node",
      },
      {
        url: "https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/100/external-mongodb-a-cross-platform-document-oriented-database-program-logo-shadow-tal-revivo.png",
        name: "mongoDB",
      },
      {
        url: "https://img.icons8.com/color/256/express-js.png",
        name: "express-js",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://wingshooter.vercel.app/",
    github: "https://github.com/DeshmukhMandar3/WingShooter",
  },
  {
    project_img: "./pharmeasy.png",
    project_img_dark: "./pharmeasy_dark.png",
    title: "PharmEasy",
    description:
      "This was an individual project. PharmEasy online store from where users can buy medicines and take services like lab tests etc. In my role as an individual contributor, I utilized an extensive range of cutting-edge technologies to create a seamless user experience. This included the use of React, HTML, CSS, and Javascript for development, alongside Chakra  for UI design and development.",
    tech_stack: [
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
        name: "react",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
        name: "html",
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
        name: "css",
      },
      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png",
        name: "chakra",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://dispensable-underwear-8715.vercel.app/",
    github: "https://github.com/Rajendra3049/PharmEasy.com-Clone",
  },
  {
    project_img: "./lifestore.png",
    project_img_dark: "./lifestore_dark.png",
    title: "Lifestyle Store",
    description:
      "This was a group project.We have created these website with the help of HTML, CSS And Javascript.My work was here to create Product's Page, Product's Details Page, Payment Page,Cart Page and Checkout Page.This was a collaborative project built by team of 5 members in 5 days.",
    tech_stack: [
      {
        url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
        name: "html",
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
        name: "css",
      },
      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://lifestylestore-com-clone.vercel.app/",
    github: "https://github.com/Rajendra3049/Lifestylestore.com-Clone",
  },
  {
    project_img: "./cricket.png",
    project_img_dark: "./cricket_dark.png",
    title: "Cricket.com",
    description:
      " This was an individual project.The website, cricket.com, served as an informational hub providing users with updates on match scores, news, videos, and other relevant information pertaining to cricket.",
    tech_stack: [
      {
        url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
        name: "html",
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
        name: "css",
      },
      {
        url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
        name: "js",
      },
      {
        url: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
        name: "github",
      },
    ],
    link: "https://masai-unit2-construct-week-project.netlify.app/",
    github: "https://github.com/Rajendra3049/Cricket.com-Clone",
  },
];
